<script setup>
const props = defineProps({
  content: { type: String, default: '' },
  isLoading: { type: Boolean, default: false },
});

const emit = defineEmits(['edit', 'send', 'dismiss']);

const handleEdit = () => emit('edit');
const handleSend = () => emit('send');
const handleDismiss = () => emit('dismiss');
</script>

<template>
  <div
    class="rounded-xl border border-n-weak bg-n-alpha-black2 p-4 text-sm text-n-slate-12"
  >
    <div class="flex items-start justify-between gap-3">
      <div class="flex-1">
        <p class="mb-1 text-xs font-semibold text-n-slate-11">
          {{ $t('AI_REPLY_SUGGESTION.LABEL') }}
        </p>
        <p
          v-if="isLoading"
          class="text-sm text-n-slate-11"
          data-test-id="ai-reply-suggestion-loading"
        >
          {{ $t('AI_REPLY_SUGGESTION.LOADING') }}
        </p>
        <p v-else class="text-sm" data-test-id="ai-reply-suggestion-content">
          {{ content }}
        </p>
      </div>
      <button
        type="button"
        class="text-n-slate-10 hover:text-n-slate-12"
        data-test-id="ai-reply-suggestion-dismiss"
        @click="handleDismiss"
      >
        {{ $t('AI_REPLY_SUGGESTION.DISMISS') }}
      </button>
    </div>
    <div class="mt-3 flex gap-2">
      <button
        type="button"
        class="reset-base inline-flex items-center justify-center rounded-lg bg-n-brand px-3 py-1.5 text-xs font-semibold text-white transition hover:bg-n-brand/90"
        data-test-id="ai-reply-suggestion-edit"
        :disabled="isLoading || !content"
        @click="handleEdit"
      >
        {{ $t('AI_REPLY_SUGGESTION.EDIT') }}
      </button>
      <button
        type="button"
        class="reset-base inline-flex items-center justify-center rounded-lg border border-n-weak px-3 py-1.5 text-xs font-semibold text-n-slate-12 transition hover:border-n-slate-6"
        data-test-id="ai-reply-suggestion-send"
        :disabled="isLoading || !content"
        @click="handleSend"
      >
        {{ $t('AI_REPLY_SUGGESTION.SEND') }}
      </button>
      <button
        type="button"
        class="reset-base inline-flex items-center justify-center rounded-lg border border-n-weak px-3 py-1.5 text-xs font-semibold text-n-slate-12 transition hover:border-n-slate-6"
        :disabled="isLoading"
        @click="handleDismiss"
      >
        {{ $t('AI_REPLY_SUGGESTION.CLOSE') }}
      </button>
    </div>
  </div>
</template>
